import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-shrink-0" }
const _hoisted_2 = { class: "d-flex ms-3" }
const _hoisted_3 = {
  href: "#",
  class: "btn btn-flex flex-center btn-bg-white btn-text-gray-500 btn-active-color-primary w-40px w-md-auto h-40px px-0 px-md-6",
  tooltip: "New Customer",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_create_account"
}
const _hoisted_4 = { class: "svg-icon svg-icon-2 svg-icon-primary me-0 me-md-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-inline" }, "New Customer", -1)
const _hoisted_6 = { class: "d-flex ms-3" }
const _hoisted_7 = {
  href: "#",
  class: "btn btn-flex flex-center btn-bg-white btn-text-gray-500 btn-active-color-primary w-40px w-md-auto h-40px px-0 px-md-6",
  tooltip: "New Invoice",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_create_invoice",
  id: "kt_toolbar_primary_button"
}
const _hoisted_8 = { class: "svg-icon svg-icon-2 svg-icon-primary me-0 me-md-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-inline" }, "New Invoice", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr075.svg" })
        ]),
        _hoisted_5
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("a", _hoisted_7, [
        _createElementVNode("span", _hoisted_8, [
          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen005.svg" })
        ]),
        _hoisted_9
      ])
    ])
  ]))
}